import { Component, Input, ViewEncapsulation } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CerrixTextInputBase } from "../cerrix-textinput-base";
import { InputTooltipDirective } from "@app/shared/directives/input-tooltip.directive";
import { TextAreaAutoGrowDirective } from "@app/shared/directives/textarea-auto-grow";

@Component({
    selector: "cerrix-textarea",
    templateUrl: "./cerrix-textarea.component.html",
    styleUrls: ["./cerrix-textarea.component.scss"],
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule, InputTooltipDirective, TextAreaAutoGrowDirective]
})
export class CerrixTextAreaComponent extends CerrixTextInputBase {
    @Input() rows = 3;
    @Input() autoGrowEnabled = false;

    public constructor() {
        super();

        this.control.valueAccessor = this;
        this.multiline = true;
    }
}
